import scrollLock from '../functions/_scrollLock.js' // スクロールロック

overlayItem('#sp-menu-open,.sp-menu-close,#sp-menu a,#overlay', '#sp-menu-open,#sp-menu,#overlay')
function overlayItem(triggerSelector, targetSelector) {
  const spMenuTrigger = document.querySelectorAll(triggerSelector)
  const spMenuTarget = document.querySelectorAll(targetSelector)
  for (let index = 0; index < spMenuTrigger.length; index++) {
    const element = spMenuTrigger[index]
    element.addEventListener(
      'click',
      function (e) {
        // 指定のクラスを持つ
        let isActive = false
        if (e.target.classList.contains('active')) {
          isActive = true
        }

        for (let index = 0; index < spMenuTarget.length; index++) {
          const element = spMenuTarget[index]
          if (!isActive) {
            element.classList.add('active')
          } else {
            element.classList.remove('active')
          }
        }
        scrollLock('body', '#overlay')
      },
      false
    )
  }
}
